angular.module("Main").controller("ShopStep2Controller", ["$rootScope", "$scope", "$state", "$localStorage", "$uibModal", "$window", "$stateParams", "$location", "$translate", "DialogService", "ShopService", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $localStorage, $uibModal, $window, $stateParams, $location, $translate, DialogService, ShopService, PaymentService, BookingService, SessionService) {
        var vm = this;

        vm.accepted = false;
        vm.openedMenuBar = false;
        vm.showPayments = false;
        vm.choosenPaymentMethod = null;
        vm.reservationError = false;
        vm.errorRegisterDialog = false;

        vm.endTextFree = "T_Jetzt_kostenlos_buchen"
        vm.endTextVorOrt = "T_Jetzt_buchen_und_vor_Ort_bezahlen"
        vm.endTextZurBezahlmoeglichkeiten = "T_Zur_Bezahlungsmöglichkeiten";

        vm.showPaymentMethods = function () {
            vm.showPayments = true;
        };

        vm.payNow = function (method) {
            if (method === 'pp') {
                bookPayPal();
            }

            if (method === 'ls' || method === 'vor Ort') {
                bookWithoutPayment(method);
            }
        };

        var loginHandler = $rootScope.$on("login", function (event, data) {
            checkUser();
            init();
            checkMVPrice();
        });

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'shopData');
            $localStorage.user = {};
            unregisterEventHandler();
            $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});
        });

        if (!SessionService.getSessionId()) {
            unregisterEventHandler();
            $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});
        } else
            start();

        function start() {
            vm.cookies = SessionService.checkSession();
            if (!_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username)) {
                checkMVPrice();
            }
            checkUser();
            init();
        }

        loadConfigs();
        getKursbuchungLayouKonfiguration();


        function checkMVPrice() {
            ShopService.checkMvPrice(vm.cookies.shopData.ArtikelNr, $localStorage.user.uid).then(function (data) {
                if (data != null && data !== "") {
                    vm.shopData.Preis = data.Price;
                    SessionService.setShopMVPrice(data.Price)
                }
            })
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        $('#register-focus').autofocus;

        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        function checkUser() {
            if ($localStorage.user && !_.isUndefined($localStorage.user.expiryTime)) {
                let expiryTime = JSON.parse($localStorage.user.expiryTime);
                let now = new Date;
                if (now.getTime() > expiryTime) {
                    SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData', 'shopData');
                    vm.isLoggedIn = false;
                    vm.username = "";
                    $localStorage.user = {};
                    $rootScope.$emit("logout");
                    $state.go('shop', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()})
                }
            }
            vm.isMember = $localStorage.user && $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
            vm.currentUser = $localStorage.user;
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;
        }

        function init() {
            if (_.isNil(vm.cookies.shopData) || _.isNil(vm.cookies.shopData)) {
                unregisterEventHandler();
                $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});
            } else {
                //ToDo check Price nach Tag bzw Member Rabatt?
                vm.shopData = vm.cookies.shopData;
                vm.selectedPayment = "0";
                BookingService.loadConfigurationStammdaten().then(function (texts) {
                    vm.stammdatenBestaetigung = texts.BestaetigungStammdaten;
                    if (texts.TextObligatory) {
                        vm.endTextFree = "T_Jetzt_verpflichtend_bestellen";
                        vm.endText = "T_Jetzt_kostenpflichtig_bestellen";
                        vm.endTextZuPayPal = "T_Bezahlen_mit_PayPal"
                    } else {
                        vm.endTextFree = "T_Jetzt_bestellen";
                        vm.endText = "T_Jetzt_kostenpflichtig_bestellen";
                        vm.endTextZuPayPal = "T_Bezahlen_mit_PayPal"
                    }
                });
            }
        }


        vm.bookAsLoggedInVorOrt = function (method) {
            init();
            bookWithoutPayment(method);
        };

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.BuchungslimitMitgliedZulassen = data.BuchungslimitMitgliedZulassen;
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.privacytermsText = data.PrivacyPolicy;
            });
        }

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.loginModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/Main/views/dialogs/login.html",
                controller: "LoginDialogController",
                controllerAs: "vm",
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function (data) {
                if (!_.isNil(data)) {
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 * 1000;
                    vm.isLoggedIn = true;
                    checkMVPrice();
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            });
        };

        vm.registerModal = function () {
            SessionService.clear('globals');
            DialogService.openRegisterDialog(vm.shopData.Preis).then(function (data) {
                if (!_.isNil(data)) {
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 * 1000;
                    vm.isLoggedIn = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            }).catch(function () {
                vm.errorRegisterDialog = true;
            })
        };


        //ToDo Preis
        function bookWithoutPayment(method) {
            if (!vm.spinner) {
                let articleBooking = {
                    PersonNr: vm.currentUser.uid,
                    ArtikelNr: vm.shopData.ArtikelNr,
                    Language: $translate.use(),
                    Zahlart: method,
                    Preis: vm.shopData.Preis,
                    Bezeichnung: vm.shopData.Bezeichnung
                };
                vm.spinner = true;
                ShopService.createShopBooking(articleBooking).then(function (data) {
                    vm.spinner = false;
                    unregisterEventHandler();
                    $state.go('shop_success', {
                        cid: SessionService.getAuthData(),
                        locale: true,
                        oid: data.orderId,
                        id: SessionService.getAuthIdData(),
                        qr: data.QRCode
                    });
                }).catch(function (error) {
                        vm.spinner = false;
                        $state.go("shop_fail", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), oid: error.data.oid});
                    }
                )
            }
        }

        function bookPayPal() {
            if (!vm.spinner) {
                let articleBooking = {
                    PersonNr: vm.currentUser.uid,
                    ArtikelNr: vm.shopData.ArtikelNr,
                    Language: $translate.use(),
                    LinkId: $stateParams.id,
                    Zahlart: _.upperCase('pp'),
                    Preis: vm.shopData.Preis,
                    Bezeichnung: vm.shopData.Bezeichnung
                };
                vm.spinner = true;
                ShopService.startShopPaymentPayPal(articleBooking).then(function (url) {
                    vm.spinner = false;
                    unregisterEventHandler();
                    $window.location.href = url.redirectUrl;
                }).catch(function (error) {
                    //ToDo Error Node / API / Text
                    vm.spinner = false;
                    $state.go("shop_fail_pp", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        oid: error.data.oid,
                        message: error.data.message
                    });
                })
            }
        }

        vm.showPaymentMethods = function () {
            vm.showPayments = true;
        };

        vm.goToAngebot = function () {
            $state.go('shop', {cid: $stateParams.cid, id: $stateParams.id});
            vm.openedMenuBar = false;
        };

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

    }])